export interface UploadFilesPermissions {
  canDelete: boolean
  canUpload: boolean
  canDownload: boolean
}

export const DEFAULT_UPLOAD_FILES_PERMISSIONS: UploadFilesPermissions = {
  canDelete: true,
  canUpload: true,
  canDownload: true,
}

export function resolveUploadFilesPermissions(
  permissions?: UploadFilesPermissions | null
): UploadFilesPermissions {
  return permissions ?? DEFAULT_UPLOAD_FILES_PERMISSIONS
}
